export * from "./OmnitureAnalytics/forexEvents";
export * from "./OmnitureAnalytics/constants";
export {
  getCommonOmniData,
  getCommonSeoOmniData,
} from "./OmnitureAnalytics/common";
export { getDeviceTypeForOmniture } from "./OmnitureAnalytics/common";
